import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader";
import { type FC, Suspense, lazy } from "react";

const ResetPasswordPage = lazy(() => import("./ResetPasswordPage"));

const ResetPasswordPageLazy: FC = () => {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <ResetPasswordPage />
    </Suspense>
  );
};

export default ResetPasswordPageLazy;
